import type { ReferenceRendererProps } from '@contember/react-client'
import React from 'react'
import type { ContentBlockReference } from '../queries/ContentQuery'

export const anchor = ({ children, reference }: ReferenceRendererProps<ContentBlockReference>) => {
	console.log(children)
	return <span id={reference.primaryText} className="content anchor"></span>
}
